/**
 * The slot registrations of `web/reference`: the Reference tab (`rail.tabs.reference`, order 70).
 * `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/reference']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { lazy } from 'react';

/** Loaded on first use: the tab reads the editor package, which this module's importers need not evaluate. */
const ReferenceTab = lazy(() =>
  import('./rail/ReferenceTab.js').then((module) => ({ default: module.ReferenceTab })),
);

export const owner: WorkPackageId = '1.AB-2';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'rail.tabs', order: 70, owner: '1.AB-2', component: ReferenceTab },
];
